export function removeDuplicatesFromEventBatches(one, two) {
    if (one.length == 0 || two.length == 0) {
        return two;
    }
    const lastTime = one[one.length - 1].time;
    const lastTypes = [];
    //собираем в массив типы всех последних событий в первой пачке,
    // случившихся в одну секунду
    for (let i = one.length - 1; i >= 0; i--) {
        if (one[i].time == lastTime) {
            lastTypes.push(one[i].type);
        }
        else {
            break;
        }
    }
    //идём сначала второй пачки и проверяем все события до следующей секунды
    //удаляем все события, которые совпадают с хвостом первой пачки
    let pos = 0;
    for (; pos < two.length; pos++)
        if (two[pos].time != lastTime) {
            break;
        }
    if (pos == 0) {
        return two;
    }
    return [
        ...two.slice(0, pos).filter((ev) => !lastTypes.includes(ev.type)),
        ...two.slice(pos),
    ];
}
